import { Badge, type BadgeProps } from "@mantine/core";

export const drofusDisciplineColorById: Record<string, string> = {
  RIE: "#f59f00",
  RIKT: "#1971c2",
  RIAut: "#9c36b5",
  RIV: "#0c8599",
};

type DrofusDisciplineBadgeProps = {
  discipline: string;
  active?: boolean;
  onClick?: () => void;
  size?: BadgeProps["size"];
};

export const DrofusDisciplineBadge: React.FC<DrofusDisciplineBadgeProps> = ({
  discipline,
  active = false,
  onClick,
  size = "sm",
}) => {
  const color = drofusDisciplineColorById[discipline] ?? "#868e96";
  const interactive = typeof onClick === "function";

  return (
    <Badge
      component={interactive ? "button" : "div"}
      type={interactive ? "button" : undefined}
      size={size}
      radius="sm"
      onClick={onClick}
      styles={{
        root: {
          backgroundColor: active ? `${color}1a` : "#ffffff",
          border: `1px solid ${color}`,
          color,
          cursor: interactive ? "pointer" : "default",
          fontWeight: 700,
          textTransform: "none",
        },
        label: { color: "inherit" },
      }}
    >
      {discipline.toUpperCase()}
    </Badge>
  );
};
